import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Table,
  Badge,
  ModalFooter,
  Button,
} from "reactstrap";

const ViewExtraChargesModal = ({ show, toggle, bill }) => {
  if (!bill) return null;

  return (
    <Modal isOpen={show} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>
        Extra Charges Invoice — #{bill.invoiceNo}
      </ModalHeader>

      <ModalBody>
        {/* ---- BILL HEADER BOX ---- */}
        <div className="border rounded p-4 mb-4">
          <Row>
            <Col md={6}>
              <h6 className="text-uppercase text-muted fw-semibold mb-2">
                Customer Details
              </h6>

              <div className="small">
                Name: <b>{bill.customerName} </b>
              </div>
              <div className="small  ">
                Address: <b>{bill.customerAddress} </b>
              </div>
              <div className="small">
                GST No: <b>{bill.customerGSTNo}</b>
              </div>
            </Col>

            <Col md={6} className="text-end">
              <h6 className="text-uppercase text-muted fw-semibold mb-2">
                Invoice Details
              </h6>

              <div className="small">
                <span className="text-muted">Invoice No: </span>
                <b>{bill.invoiceNo}</b>
              </div>
              <div className="small">
                <span className="text-muted">Bill Date: </span>
                <b>{bill.billDate}</b>
              </div>
              <div className="small">
                <span className="text-muted">Session: </span>
                <b>{bill.sessionName}</b>
              </div>
            </Col>
          </Row>
        </div>

        {/* ---- TRIP DETAILS TABLE ---- */}
        <h6 className="text-uppercase fw-semibold text-muted mb-2">
          Trip / Vehicle Details
        </h6>

        <Table responsive className="invoice-table mb-4">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Trip Date</th>

              <th>Supplier</th>
              <th>Vehicle No</th>
              <th>Trip No</th>
              <th>Trip Type</th>
              <th>KM/Trip</th>
              <th>Toll Charges</th>
              <th>Handling Charges</th>
              <th>Other Charges</th>
            </tr>
          </thead>

          <tbody>
            {bill.chargesInvoiceResponses?.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.tripDate}</td>
                <td>{item.suppliersName}</td>
                <td>{item.vehicleNo}</td>
                <td>{item.tripNo}</td>
                <td>
                  <Badge color="info" pill>
                    {item.tripType}
                  </Badge>
                </td>
                <td>{item.kmOrTrip}</td>
                <td>{item.tollCharges}</td>
                <td>{item.handlingCharges}</td>
                <td>{item.otherCharges}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        {/* ---- TOTALS SECTION ---- */}
        <div className=" rounded p-4">
          <Row>
            <Col md={6}>
              <h6 className="text-uppercase text-muted fw-semibold mb-3">
                Extra Charges Summary
              </h6>

              <div className="mb-1 d-flex justify-content-between">
                <span>Toll Charges</span>
                <strong>₹{bill.tollCharges}</strong>
              </div>

              <div className="mb-1 d-flex justify-content-between">
                <span>Other Charges</span>
                <strong>₹{bill.otherCharges}</strong>
              </div>

              <div className="mb-1 d-flex justify-content-between">
                <span>Handling Charges</span>
                <strong>₹{bill.handlingCharges}</strong>
              </div>

              <div className="border-top pt-2 d-flex justify-content-between">
                <span>Total Amount</span>
                <strong>₹{bill.totalAmount}</strong>
              </div>
            </Col>
            <Col
              className="text-end d-flex flex-column fw-semibold  text-uppercase justify-content-end"
              md={6}
            >
              <strong> Note : ₹{bill?.note}</strong>
            </Col>

            {/* GRAND TOTAL */}
            <Col
              md={6}
              className="text-end d-flex flex-column justify-content-end"
            >
              <span className="fw-semibold text-muted text-uppercase">
                Grand Total
              </span>
              <h2 className="fw-bold text-success mb-0">₹{bill.totalAmount}</h2>
            </Col>
          </Row>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" className="btn-sm" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ViewExtraChargesModal;
